import { h } from "snabbdom";
import { ELEMENT_TYPE } from "./constants";
import {
  SlateEditor,
  SlateElement,
  SlateTransforms,
  DomEditor,
} from "@wangeditor/editor";
import { uploadFilToCdn } from "@saas/components/src/utils/cos-upload";
import LoadingImg from "@saas/components/assets/images/video-loading.gif";
import RefreshImg from "@saas/components/assets/images/wang-editor/refresh.png";
import DeleteIcon from "@saas/components/assets/images/wang-editor/delete.png";
// 渲染节点
/**
 * @param elem 标记块元素
 * @param children 元素子节点
 * @param editor 编辑器实例
 * @returns vnode 节点（通过 snabbdom.js 的 h 函数生成）
 */
const renderToELem = (elem, children, editor) => {
  const {
    file,
    isError,
    isLoading,
    isLoaded,
    width = "272px",
    height = "153px",
    url = "",
  } = elem;
  const path = DomEditor.findPath(editor, elem);
  if (!file && !url) {
    return createElem(elem, children, editor, "error");
  } else if (isLoading) {
    return createElem(elem, children, editor, "loading");
  } else if (isError) {
    return createElem(elem, children, editor, "error");
  } else if (isLoaded) {
    return createElem(elem, children, editor, "loaded");
  } else {
    if (url.indexOf("saas-api-1324980469.cos.ap-beijing.myqcloud.com") >= 0 ||
        url.indexOf("cdn.moguocdn.com") >= 0) {
      const img = new Image();
      img.src = url;
      img.onload = () => {
        onSuccess(elem, children, editor);
        return;
      };
      img.onerror = (error) => {
        onError(elem, children, editor);
      };
    } else if (file) {
      uploadFile(file, elem, editor);
    } else if (url) {
      // 生成blob
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          // 生成一个文件对象
          const newFile = new File([blob], "image.png", {
            type: blob.type,
          });
          uploadFile(newFile, elem, editor);
        })
        .catch((err) => {
          onError(elem, children, editor);
        });
    }
    onLoading(elem, children, editor);
    return createElem(elem, children, editor, "loading");
  }
};
// 创建loading 节点
const createElem = (elem, children, editor, status) => {
  const { url, width = "360px", height = "153px" } = elem;
  const path = DomEditor.findPath(editor, elem);
  editor.emit("xhInsertImageUploadStatus", {
    status: status,
    elem,
  });
  if (status === "loaded") {
    const image = h(
      "img",
      {
        attrs: {
          src: url,
          style: {
            width: width,
            height: height,
          },
        },
      },
      [{ text: "" }]
    );

    const deleteVnode = h(
      // HTML tag
      "img",
      // HTML 属性、样式、事件
      {
        key: new Date().getTime(),
        props: {
          src: DeleteIcon,
        }, // HTML 属性，驼峰式写法
        style: {
          minWidth: "16px",
          minHeight: "16px",
          width: "16px",
          height: "16px",
          cursor: "pointer",
        }, // HTML style ，驼峰式写法
      }
    );
    // 删除按钮
    const deleteBox = h(
      "div",
      {
        props: {
          contentEditable: false,
        },
        attrs: {
          class: "delete-icon",
        },
        style: {
          width: "20px",
          height: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          position: "absolute",
          right: "8px",
          top: "8px",
          background: "#F2F3F5",
          borderRadius: "6px",
        },
        on: {
          click: () => {
            SlateTransforms.removeNodes(editor, {
              at: path,
              mode: "highest",
            });
          },
        },
      },
      [deleteVnode]
    );

    return h(
      ELEMENT_TYPE,
      {
        key: new Date().getTime(),
        props: {
          contentEditable: false,
        },
        style: {
          display: "inline-block",
          maxWidth: "100%",
          maxHeight: "100%",
          background: "var(--wang-editor-mark-block-bg, #f5f7fa)",
          margin: "8px 0",
          position: "relative",
        },
      },
      [image, deleteBox]
    );
  } else {
    let img = "";
    let text = "";
    if (status === "loading") {
      img = LoadingImg;
      text = "加载中...";
    } else if (status === "error") {
      img = RefreshImg;
      text = "重新加载";
    } else if (status === "loaded") {
      img = "";
    }
    const deleteVnode = h(
      // HTML tag
      "img",
      // HTML 属性、样式、事件
      {
        key: new Date().getTime(),
        props: {
          src: DeleteIcon,
        }, // HTML 属性，驼峰式写法
        style: {
          minWidth: "16px",
          minHeight: "16px",
          width: "16px",
          height: "16px",
          cursor: "pointer",
        }, // HTML style ，驼峰式写法
      }
    );
    // 删除按钮
    const deleteBox = h(
      "div",
      {
        props: {
          contentEditable: false,
        },
        style: {
          width: "20px",
          height: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          position: "absolute",
          right: "8px",
          top: "8px",
          background: "#F2F3F5",
          borderRadius: "6px",
        },
        on: {
          click: () => {
            SlateTransforms.removeNodes(editor, {
              at: path,
              mode: "highest",
            });
          },
        },
      },
      [deleteVnode]
    );

    const imgLoadingVnode = h("img", {
      src: img,
      alt: "加载中",
      style: {
        width: "50px",
        height: "auto",
        cursor: "pointer",
      },
    });
    const loadingTextVnode = h(
      // HTML tag
      "span",
      // HTML 属性、样式、事件
      {
        key: new Date().getTime(),
        props: { contentEditable: false }, // HTML 属性，驼峰式写法
        style: {
          height: "24px",
          lineHeight: "24px",
          display: "inline-block",
          textAlign: "center",
          fontSize: "12px",
          color: "var(--wang-editor-mark-block-muted-text, #86909c)",
          cursor: "pointer",
        },
      },
      text
    );
    const wrapperVnode = h(
      "div",
      {
        key: new Date().getTime(),
        props: {
          contentEditable: false,
        },
        style: {
          width: "100%",
          height: "100%",
          background: "var(--wang-editor-mark-block-bg, #f5f7fa)",
          borderRadius: "6px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          position: "relative",
        },
        on: {
          click: () => {
            if (status === "error") {
              onReload(elem, children, editor);
            }
          },
        },
      },
      [imgLoadingVnode, loadingTextVnode, deleteBox]
    );
    const vnode = h(
      ELEMENT_TYPE,
      {
        key: new Date().getTime(),
        props: {
          contentEditable: false,
        },
        style: {
          width: "100%",
          maxWidth: "360px",
          height: height,
          background: "var(--wang-editor-mark-block-bg, #f5f7fa)",
          borderRadius: "6px",
          border: "1px solid var(--wang-editor-mark-block-border, #f2f3f5)",
          display: "block",
          cursor: "pointer",
          margin: "8px 0",
          position: "relative",
        },
        on: {
          click: () => {
            if (status === "error") {
              onReload(elem, children, editor);
            }
          },
        },
      },
      [wrapperVnode, ...children]
    );
    return vnode;
  }
};
// 失败点击重新加载
const onReload = (elem, children, editor) => {
  const path = DomEditor.findPath(editor, elem);
  const { url, file } = elem;
  SlateTransforms.setNodes(
    editor,
    {
      url: url,
      file: file,
      children: children,
      isLoaded: false,
      isLoading: false,
      isError: false,
      t: new Date().getTime(),
    },
    {
      at: path,
      mode: "highest",
      voids: true,
    }
  );
};
// 加载失败
const onError = (elem, children, editor) => {
  const path = DomEditor.findPath(editor, elem);
  const { url, file } = elem;
  SlateTransforms.setNodes(
    editor,
    {
      url: url,
      file: file,
      children: children,
      t: new Date().getTime(),
      isError: true,
      isLoading: false,
      isLoaded: false,
    },
    {
      at: path,
      mode: "highest",
    }
  );
};
// 加载成功
const onSuccess = (elem, children, editor) => {
  const path = DomEditor.findPath(editor, elem);
  const { url, file } = elem;
  SlateTransforms.setNodes(
    editor,
    {
      url: url,
      file: file,
      children: children,
      isLoaded: true,
      isLoading: false,
      isError: false,
      t: new Date().getTime(),
    },
    {
      at: path,
      mode: "highest",
      voids: true,
    }
  );
};
// loading
const onLoading = (elem, children, editor) => {
  const path = DomEditor.findPath(editor, elem);
  const { url, file } = elem;
  SlateTransforms.setNodes(
    editor,
    {
      url: url,
      file: file,
      children: children,
      isLoading: true,
      isLoaded: false,
      isError: false,
      t: new Date().getTime(),
    },
    {
      at: path,
      mode: "highest",
      voids: true,
    }
  );
};
// 上传图片
const uploadFile = (file, elem, editor, children) => {
  const uploadImageConfig = editor.getMenuConfig("uploadImage");
  uploadFilToCdn(
    file,
    { type: 104 },
    {
      onSuccess: (res) => {
        const img = new Image();
        img.src = res.url;
        img.onload = () => {
          const path = DomEditor.findPath(editor, elem);
          const { url, file } = elem;
          SlateTransforms.setNodes(
            editor,
            {
              url: res.url,
              file: file,
              children: children,
              isLoaded: true,
              isLoading: false,
              isError: false,
              t: new Date().getTime(),
            },
            {
              at: path,
              mode: "highest",
              voids: true,
            }
          );
          // onSuccess(elem, children, editor);
        };
        img.onerror = (error) => {
          onError(elem, children, editor);
        };
      },
      onError: (err) => {
        onError(elem, children, editor);
      },
      onProgress: (progress) => {
        uploadImageConfig.onProgress(progress);
      },
    }
  );
};
// 编辑器渲染配置
export const renderToElemConfig = {
  type: ELEMENT_TYPE,
  renderElem: renderToELem,
};
